import { Trans } from '@lingui/react/macro';
import { NoddiBasicCard, NoddiButton } from 'noddi-ui-web';
import { useState } from 'react';
import { CustomerSMSLogin } from './CustomerSMSLogin';

interface BenefitsLoginProps {
  activateMemberShipAfterLogin?: (groupId: number | null, phoneNumber?: string) => Promise<void>;
  defaultOpen?: boolean;
  buttonText?: string;
}
export const BenefitsCustomerSMSLogin = ({
  activateMemberShipAfterLogin,
  defaultOpen,
  buttonText
}: BenefitsLoginProps) => {
  const [showLogin, setShowLogin] = useState(!!defaultOpen);

  if (!showLogin) {
    return (
      <NoddiButton onClick={() => setShowLogin(true)}>
        {buttonText ? <span>{buttonText} </span> : <Trans>Sign in to activate your benefits</Trans>}
      </NoddiButton>
    );
  }

  return (
    <NoddiBasicCard className='flex flex-col'>
      <p className='font-semibold'>
        <Trans>To activate your benefits, we first need to verify your phone number</Trans>
      </p>
      <div className='flex flex-col gap-2'>
        <p className='opacity-80'>
          <Trans>We will create a user for you, if you do not have one</Trans>
        </p>
        <div>
          <CustomerSMSLogin
            hidePhoneNumberText
            // oxlint-disable-next-line typescript/no-misused-promises -- async onLoginSuccess; React discards the returned promise, so a rejection is unhandled unless the body catches
            onLoginSuccess={async (data) => {
              await activateMemberShipAfterLogin?.(
                data.user.userGroups[0]?.id ?? null,
                data.user.phoneNumber ?? undefined
              );
            }}
          />
        </div>
      </div>
    </NoddiBasicCard>
  );
};
